// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { isDefined, isEmpty } from '@automator/utilities';

// Import style for web component
import styles from './web-component-style.scss';

// Get translatable strings
// const strings = UncannyAutomatorBackend.logs.components.logStatus.i18n;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-integration-icon' )
export class AutomatorLogIntegrationIcon extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: String, attribute: 'integration-id' } ) accessor integrationID;

	@property( { type: String } ) accessor size; // xsmall (75%), small (87.5%), large (125%), xlarge (150%), 2x, 16 (16px), 24 (24px), 32 (32px), 40 (40px), 64 (64px)

	// Whether to show the tooltip with the name of the integration or not
	@property( { type: Boolean, attribute: 'show-tooltip' } ) accessor showTooltip = false;

	// eslint-disable-next-line require-jsdoc
	render() {
		// If we don't have to show the tooltip, OR if the integration name is not available, just return the icon
		if ( ! this.showTooltip || isEmpty( this.integrationName ) ) {
			return this._templateLogIcon;
		}

		// Show the tooltip
		return html`
			<uo-tooltip>
				<span class="tooltip-nowrap">${ this.integrationName }</span>

				<div slot="target">
					${ this._templateLogIcon }
				</div>
			</uo-tooltip>
		`;
	}

	/**
	 * Returns the main template that contains the icon
	 *
	 * @return {TemplateResult} The icon
	 */
	get _templateLogIcon() {
		return html`
			<div class="log-icon">
				<uo-icon integration="${ this.integrationID }" size="${ ifDefined( this.size ) }"></uo-icon>
			</div>
		`;
	}

	/**
	 * Tries to get the integration name
	 *
	 * @return {String} The integration name
	 */
	get integrationName() {
		try {
			return UncannyAutomatorBackend.components.icon.integrations[ this.integrationID ].name;
		} catch ( e ) {
			return;
		}
	}
}